import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/Auth/PrivateRoute';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import LogForm from './components/ProductionLog/LogForm';
import LogList from './components/ProductionLog/LogList';
import ProductionRates from './components/Analytics/ProductionRates';
import Estimator from './components/Analytics/Estimator';
import FormworkEfficiency from './components/Analytics/FormworkEfficiency';
import EquipmentUtilization from './components/Analytics/EquipmentUtilization';
import ProjectList from './components/Projects/ProjectList';
import CugPage from './components/cug-section/CugPage'; 
import ProjectDetail from './components/Projects/ProjectDetail';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/grug" element={<CugPage />} />
          
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="logs/new" element={<LogForm />} />
            <Route path="logs" element={<LogList />} />
            <Route path="analytics/rates" element={<ProductionRates />} />
            <Route path="analytics/estimator" element={<Estimator />} />
            <Route path="analytics/formwork" element={<FormworkEfficiency />} />
            <Route path="analytics/equipment" element={<EquipmentUtilization />} />
            <Route path="projects" element={<ProjectList />} />
            <Route path="projects/:projectId" element={<ProjectDetail />} />

          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;